<template>
  <div class="container">
    <!-- <div class="perInfo">
      <img :src="perInfo.help" />
      <div>
        <div class="name">{{ perInfo.name }}</div>
        <div>{{ perInfo.phone }}</div>
      </div>
    </div> -->
    <HeadInfo :infoObj="perInfo" :key="time"></HeadInfo>
    <template v-if="!perInfo.who">
      <div class="entrance">
        <div class="imgSty" @click="toPath('control')">
          <img
            src="@/assets/images/squirrelCup/2024/cupTwo/guankong.png"
            alt=""
          />
          <!-- <div class="dingwei">
            <van-icon name="arrow" size="18" />
          </div> -->
        </div>
        <div class="imgSty" @click="toPath('extra')">
          <img
            src="@/assets/images/squirrelCup/2024/cupTwo/jiangli.png"
            alt=""
          />
          <!-- <div class="dingwei">
            <van-icon name="arrow" size="18" />
          </div> -->
        </div>
      </div>
    </template>
    <div class="tipSty">
      <div>
        本周概要（{{ filterTime(weekData.week_start) || ''}}-{{
          filterTime(weekData.week_end) || ''
        }}）
      </div>
      <div class="colSty" @click="toDetails">查看历史周报></div>
    </div>
    <div class="tipText" v-if="weekData?.suggestion >= 0.5">
      娱乐时长占比<span style="color: #ee4b4e">已超过50%</span>建议<span
        style="color: #ee4b4e"
        >管控</span
      >娱乐项目
    </div>
    <DurationStudy :particulas="weekData"></DurationStudy>
    <div class="btnSty" v-if="perInfo.who" @click="toPath('control')">
      去管控
    </div>
  </div>
</template>

<script>
import DurationStudy from "./components/DurationStudy.vue";
import HeadInfo from "./components/HeadInfo.vue";
import { entertainmenttime, getStudentInfo } from "@/api/squirrelCup";

export default {
  data() {
    return {
      perInfo: {},
      weekData: {},
      time: false,
    };
  },
  components: {
    DurationStudy,
    HeadInfo,
  },
  created() {
    this.getUserInfo();
    // this.queryEntertainmenttime();
    let time = new Date(20240408);
    document.title ="娱乐管控"

  },
  methods: {
    queryEntertainmenttime() {
      console.log(this.$route.query, this.perInfo, " this.$route.query");

      let param = {
        account_id: Number(this.perInfo.accountId),
      };
      entertainmenttime({ param }).then((res) => {
        console.log(res);
        this.weekData = res.data;
      });
    },
    filterTime(value) {
      console.log(value);
      let dateString = value || '******';
      let year = dateString?.substring(0, 4);
      let month = dateString?.substring(4, 6);
      let day = dateString?.substring(6, 8);
      return `${month}.${day}`;
    },
    getUserInfo() {
      this.perInfo = Object.assign(this.perInfo, this.$route.query);

      let param = {
        accountId: Number(this.perInfo.accountId),
      };
      getStudentInfo({ param }).then((res) => {
        if (res.data) {
          this.perInfo = Object.assign(this.perInfo, res.data);
          console.log(this.perInfo, "======");
          this.time = true;
          localStorage.setItem("headInfo", JSON.stringify(this.perInfo));
          this.queryEntertainmenttime();
        }
      });
    },
    toDetails() {
      this.$router.push({
        path: "/winterGame/weekly",
        // query: {
        //   infoObj: JSON.stringify(this.perInfo),
        // },
      });
    },
    toPath(path) {
      this.$router.push(`/winterGame/${path}`);
    },
  },
};
</script>
<style scoped lang="less">
.container {
  margin: 0px 32px;
  margin-top: 40px;
  .perInfo {
    display: flex;
    align-items: center;
    font-size: 24px;
    color: #999999;
    .name {
      font-weight: bole;
      font-size: 36px;
      color: #000000;
    }
    img {
      width: 128px;
      height: 128px;
      border-radius: 50%;
      margin-right: 24px;
    }
  }
  .entrance {
    display: flex;
    margin: 48px 26px 0px 26px;
    justify-content: space-between;
    .imgSty {
      width: 300px;
      height: 96px;
      background: linear-gradient(136deg, #f2f9ff 0%, #ddefff 100%);
      border-radius: 16px;
      position: relative;
      img {
        width: 100%;
      }
      .dingwei {
        position: absolute;
        color: #58abf6;

        right: 52px;
        top: 31px;
        /deep/.van-icon {
          position: absolute;
        }
      }
    }
  }
  .tipSty {
    display: flex;
    justify-content: space-between;
    font-size: 32px;
    margin-bottom: 16px;
    margin-top: 72px;
    .colSty {
      font-size: 28px;
      color: #58abf6;
    }
  }
  .tipText {
    margin-bottom: 32px;
    font-size: 24px;
    color: #999999;
  }
  .btnSty {
    width: 560px;
    height: 96px;
    background: linear-gradient(90deg, #2c84ff 0%, #3fc2ff 100%);
    box-shadow: 0px 8px 14px 0px #c6e8ff;
    border-radius: 51px;
    font-weight: 500;
    font-size: 36px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    margin-top: 60px;
    margin-bottom: 20px;
  }
}
</style>
